<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
const appConfig = useAppConfig()
</script>

<template>
  <h3 :class="cn(appConfig.ui.card.slots.title, props.class)">
    <slot />
  </h3>
</template>
